import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { loadState } from "../store/localStorage"

const isAuthFailure = (response) => {
    if (!response) return false
    if (response.status === 401) return true
    if (response.status !== 403) return false

    const message = `${response.data?.message || ''}`.toLowerCase()
    return message.includes('authorization token') || message.includes('token')
}

axios.interceptors.response.use(undefined, (error) => {
    const { response, config } = error
    const newResponse = {}
    const newConfig = {
        url: config.url,
        method: config.method,
        headers: config.headers
    }

    if (config.url != null) { newConfig.data = config.data }

    if (response != null) {
        if (response.status === 404) {
            return Promise.reject(error)
        }

        if (isAuthFailure(response) && window.location.pathname !== '/login') {
            window.location.replace('/logout')
        }

        newResponse.status = response.status
        newResponse.statusText = response.statusText
        newResponse.headers = response.headers

        if (response.data != null && response.data.message) {
            newResponse.dataMessage = response.data.message
        }
    }

    return Promise.reject(error)
})

export let baseURL = ''
export let APIKEY = ''
const hostname = window && window.location && window.location.hostname

switch (hostname) {
    case 'localhost':
        baseURL = 'http://localhost'
        APIKEY = 'h3u3rtK46TSVjpE1'
        break
    default:
        baseURL = 'https://canvasexpress-api-810006026250.us-central1.run.app'
        APIKEY = 'h3u3rtK46TSVjpE1'
        break
}

const getActiveToken = () => {
    return loadState()?.Auth?.token
}

export class ApiHelper {
    getAuthToken() {
        return getActiveToken()
    }

    getBaseURL() { return baseURL }

    getOutgoingHeaders() {
        return {
            'authorization': this.getAuthToken(),
            'request-id': uuidv4(),
            'Request-Source': 'canvasexpress_backoffice_ui',
            'x-api-key': APIKEY
        }
    }

    async post(url, data) {
        try {
            return axios.post(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async postWithFiles(url, data) {
        let headers = this.getOutgoingHeaders()
        headers = {
            ...headers,
            'Content-Type': 'multipart/form-data'
        }

        try {
            return axios.post(url, data, {
                baseURL,
                headers
            })
        } catch (error) {
            throw error
        }
    }

    async put(url, data) {
        try {
            return axios.put(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async get(url) {
        try {
            return axios.get(url, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async delete(url) {
        try {
            return axios.delete(url, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async download(url, data = {}, method = 'GET') {
        try {
            let response
            if (method === 'POST') {
                response = await axios.post(url, data, {
                    baseURL,
                    headers: ApiHelper.prototype.getOutgoingHeaders(),
                    responseType: 'blob'
                })
            } else {
                response = await axios.get(url, {
                    baseURL,
                    headers: ApiHelper.prototype.getOutgoingHeaders(),
                    responseType: 'blob'
                })
            }

            let filename = 'export.csv'
            const disposition = response.headers['content-disposition']
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const match = disposition.match(/filename="?([^";]+)"?/)
                if (match && match[1]) filename = match[1]
            }

            const urlBlob = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = urlBlob
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(urlBlob)
        } catch (error) {
            // Manejar error blob del backend
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text()
                    const json = JSON.parse(text)
                    error.response.data = json
                } catch (e) {
                    // No es JSON, dejar el error como está
                }
            }
            throw error
        }
    }
}

const apiHelper = new ApiHelper()

export default apiHelper
